/**
 * This file was auto-generated by Fern from our API Definition.
 */

import * as Truvity from '../../api/index';
import * as core from '../../core';
import * as serializers from '../index';

export const NotEqualPrimitiveString: core.serialization.ObjectSchema<
    serializers.NotEqualPrimitiveString.Raw,
    Truvity.NotEqualPrimitiveString
> = core.serialization.object({
    value: core.serialization.string(),
});

export declare namespace NotEqualPrimitiveString {
    export interface Raw {
        value: string;
    }
}
